import { state, transition, invoke, reduce, createMachine } from "robot3";
import { isWpSuccess, wpFetchRestApi } from "../../util";
const machine = {
    editing: state(transition('save', 'saving')),
    saving: invoke(save, transition('done', 'editing', reduce(storeSettings)), transition('error', 'error', reduce(storeError))),
    error: state(transition('save', 'saving')),
};
async function save(ctx) {
    const endpoint = 'supervisor';
    const values = ctx.values;
    const result = await wpFetchRestApi(endpoint, 'POST', { values });
    console.log({ result });
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
function storeError(ctx, ev) {
    return Object.assign(Object.assign({}, ctx), { error: ev.error.message });
}
function storeSettings(ctx) {
    return Object.assign(Object.assign({}, ctx), { values: {}, error: undefined });
}
export function create() {
    return createMachine('editing', machine, (ctx) => (Object.assign(Object.assign({}, ctx), { values: {} })));
}
